import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye el Pack Misterios?',
  a: 'Cuatro libros principales de investigación más dos selecciones extra de Murdle de regalo, todo en formato digital.'
}, {
  q: '¿Los libros son completos y están en español?',
  a: 'Sí. Son los libros en versión digital, completos y en español: todas las páginas, todos los casos y todas las soluciones. No son resúmenes ni muestras.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es una colección 100% digital: no se envían libros impresos.'
}, {
  q: '¿Cómo recibo los archivos?',
  a: 'Al confirmar el pago recibís el acceso para descargarlos al instante.'
}, {
  q: '¿Puedo imprimirlos o resolverlos en pantalla?',
  a: 'Las dos opciones. Podés imprimir las páginas que quieras o resolverlos desde el celular, la tablet o la compu.'
}, {
  q: '¿Incluye las soluciones?',
  a: 'Sí, cada libro trae las respuestas para comprobar tus investigaciones.'
}, {
  q: '¿Es una suscripción?',
  a: 'No. Es un único pago y los archivos quedan tuyos.'
}];
export const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="max-w-3xl mx-auto space-y-4" data-id="element-167" data-mp="38suf2ohwrjfe">
      {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-168" data-mp="3dm5l4newbw69" data-mpi={index}>
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F97316]" aria-expanded={openIndex === index} data-id="element-169" data-mp="3ijf71t32tppc">
            <span className="font-heading font-semibold text-[#1E1E1E] text-base md:text-lg" data-id="element-170" data-mp="f3wdfuz15dm">
              {faq.q}
            </span>
            <ChevronDown className={`text-[#F97316] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-171" data-mp="1x85lzenvkak2" />
          </button>
          <AnimatePresence data-id="element-172" data-mp="35gcngvowis4p">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-173" data-mp="35h4io5el6nug">
                <div className="px-6 pb-4 text-gray-600" data-id="element-174" data-mp="39hempcitj46o">{faq.a}</div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
};